<template>
  <div id="myAgenies">
    <v-container class="pa-0">
      <v-layout>
        <router-link to="/agencies/add">
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute right class="mr-3 pf-btn-fab">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
        </router-link>
      </v-layout>       
    </v-container>
    <v-card class="mt-3">
      <v-data-table
        disable-initial-sort
        :headers="headers"
        :items="MyAgencies"
        :search="search"
        class="pf-data-table" 
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td>{{ formatDate(getJoinDate(props.item.account), 'MM/DD/YYYY') }}</td>
          <td>{{ getStatus(props.item.account) }}</td>
          <td><span v-if="Account.default_agency === props.item.id && activeStatuses.indexOf(getStatus(props.item.account)) !== -1">Default Contact</span></td>
          <!-- <td v-else></td> -->
          <td align="right">
            <v-btn icon class="ma-0" v-if="Account.default_agency !== props.item.id && activeStatuses.indexOf(getStatus(props.item.account)) !== -1" @click="setDefaultContact(props.item)" title="Set as Default">
              <v-icon size="22" color="grey darken-2">contact_phone</v-icon>
            </v-btn> 
            <v-btn icon class="ma-0" @click="removeRequest(props.item)" :disabled="Account.default_agency === props.item.id" title="Remove">
              <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <app-modal :active="processPendingPayments" v-if="processPendingPayments" width="70%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <!-- <v-btn class="pf-modal-close" icon dark @click="{}">
              <v-icon>close</v-icon>
            </v-btn> -->
            <v-toolbar-title>Process Agency Fee</v-toolbar-title>
          </v-toolbar>

          <v-card-text class="mt-4 mb-4">
            <p class="ma-3 mb-4 pf-font-16 pf-text-red">The agency <b>{{ paymentAgency.name }}</b> has enabled a fee to get associated with them. You can either continue with payment or remove yourself from their list.</p>
            <v-form ref="checkoutForm">
              <!-- Show the initial and recurring amount -->
              <v-layout wrap class="ma-3">
                <v-flex xs4>
                  <span class="pf-font-16 font-weight-bold">Initial Amount: </span>
                  <span class="pf-font-16">{{ payment && payment.amount ? formatPrice(payment.amount) : 'Free' }}</span>
                </v-flex>
                <v-flex xs4>
                  <span class="pf-font-16 font-weight-bold">Recurring Amount: </span>
                  <span class="pf-font-16">{{ payment && payment.recurring_amount ? formatPrice(payment.recurring_amount) : 'Free' }}</span>
                </v-flex>
                <v-flex xs4>
                  <span class="pf-font-16 font-weight-bold">Payment Interval: </span>
                  <span class="pf-font-16">{{ payment && payment.recurring_billing_period ? (`${payment.recurring_billing_period} (${payment.recurring_billing_type})`) : 'Free' }}</span>
                </v-flex>
              </v-layout>
              <hr class="my-3" />
              <v-layout wrap>
                <v-flex sm6>
                  <v-layout class="flex-column pl-3">
                    <span class="pf-font-16 font-weight-bold">Choose from your cards</span>
                    <v-flex class="flex-column listCard">
                      <v-radio-group v-model="selectedCardId" return-object :disabled="!!newCard.number">
                        <v-layout v-for="(card, i) in cards" :key="i">
                          <v-flex class="flex-center">
                            <v-radio
                              :value="card.id"
                              class="flex-center"
                            >
                              <template v-slot:label>
                                <div class="flex-center">
                                  <div class="pf-card-icon" :style="`background-image:url(/static/cards/${card.icon});`"></div>
                                  #### #### #### {{ card.number.substr(card.number.length - 4) }}
                                </div>
                              </template>
                            </v-radio>
                          </v-flex>
                        </v-layout>
                        <p v-if="!cards.length">No saved cards found.</p>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex sm6>
                  <span class="pf-font-16 font-weight-bold">Use a new card</span>
                  <v-layout wrap>
                    <!-- Content -->
                    <v-flex xs12>
                      <v-text-field label="Card number" v-model.trim="newCardNumber" :rules="rules.card.number" class="required pr-3 pl-3 flex-center" @input="newCardChange($event)" placeholder="#### #### #### ####" :value="newCard.number" v-mask="'#### #### #### ####'" type="password">
                        <template v-slot:prepend>
                          <v-fade-transition leave-absolute>
                            <div class="pf-card-icon-single" :style="`background-image:url(/static/cards/${newCard.icon});`"></div>
                          </v-fade-transition>
                        </template>
                      </v-text-field>
                      <span v-if="newCardNumberMask" class="pf-pos-relative tm-20 ml-3">Card Number: {{ newCardNumberMask }}</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field v-model.trim="newCard.name" :rules="rules.card.name" label="Card holder name" class="required pr-3 pl-3"></v-text-field>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field v-model.trim="newCard.expiry" :rules="rules.card.expiry" label="Expiry date" class="required pr-3 pl-3" v-mask="'## / ##'" placeholder="MM/YY"></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field v-model.trim="newCard.cvv" :rules="rules.card.cvv" label="CVV" class="required pr-3 pl-3" v-mask="'####'" type="password" placeholder="CVV"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>

          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-3 pb-4">
            <v-btn
            class="pf-btn-text-white pf-bg-pink"
            @click="removeRequest(paymentAgency, true)"
            >
            I want to remove this agency
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="pf-btn-text-white pf-bg-green"
              @click="checkout"
            >
              Continue with payment
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>
  </div>
</template>
<script>
/* global session store config */
import { getCollection, formatDate, update, formatPrice, create, getCardType, request } from '../helpers/helpers';
import swal from 'sweetalert2';
import AppModal from '../components/AppModal';
import { mask } from 'vue-the-mask';
export default {
  components: {
    'app-modal': AppModal,
  },
  directives: { mask },
  data: (vm) => ({
    search: '',
    entity: 'Agency',
    selectedAgnecies: [],
    activeStatuses: ['Active', 'Approved'],
    headers: [
      { text: 'Agency Name', value: 'name', align: 'left' },
      { text: 'Date', value: 'createdAt' },
      { text: 'Status', value: 'status' },
      { text: '', sortable: false },
      { text: '', sortable: false },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage
    },
    processPendingPayments: false,
    paymentAgency: null,
    payment: null,
    formatPrice,
    newCardNumber: '',
    newCardNumberMask: '',
    newCard: {
      name: '',
      number: '',
      expiry: '',
      icon: 'credit-card.ico',
      type: '',
      cvv: ''
    },
    selectedCardId: null,
    isSelectCard: false,
    cards: [],
    cardIcons: [
      { type: 'Visa', icon: 'visa.png' },
      { type: 'Mastercard', icon: 'mastercard.png' },
      { type: 'American Express', icon: 'amex.png' },
      { type: 'Diners Club', icon: 'diners-club.png' },
      { type: 'Discover', icon: 'discover.jpg' },
      { type: 'JCB', icon: 'jcb.png' },
      { type: 'Unknown', icon: 'credit-card.ico' }
    ],
    rules: {
      toRule: (v) => !!v || 'Please search the agency and select',
      card: {
        number: [
          // v => Number.isInteger(v) || 'Please enter an integer',
          // v => v.length <= 16 || 'Card number should not exceed 16 digits'
        ],
        name: [v => !!v || 'Card holder name is required'],
        cvv: [v => !!v || 'CVV is required'],
        expiry: [
          v => !!v || 'Card expiry is required',
          v => vm.validateDateChange(v) || 'Date is invalid or card expired'
        ],
      }
    },
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      },
    },
    MyAgencies: {
      set (value) {
        store.commit('setMyAgencies', value);
      },
      get () {
        return store.state.MyAgencies;
      }
    },
    AgenciesRequiredPayment: {
      get () {
        return store.state.AgenciesRequiredPayment;
      },
      set (value) {
        store.commit('setAgenciesRequiredPayment', value);
      },
    },
    PaymentMode: {
      get () {
        return store.state.PaymentMode;
      },
      set (value) {
        store.commit('setPaymentMode', value);
      }
    },
  },
  watch: {
    Account (value) {
      this.Account = this.Account;
    }
  },
  async created () {
    await this.initialize();
    this.doPendingPayments();
  },
  methods: {
    getStatus (account) {
      let status = account.find(account => account.account === this.Account.id);
      if (status) {
        return status.status;
      }  
    },
    async doPendingPayments () {
      if (this.AgenciesRequiredPayment.length) {
        this.processPendingPayments = true;
        this.paymentAgency = this.AgenciesRequiredPayment[0];
        this.payment = this.paymentAgency && this.paymentAgency.additional_display_fee ? this.paymentAgency.additional_display_fee : this.payment;
        
        // List the saved cards for the family
        await this.fetchPaymentModes();
        /* Set the card icon based on card type */
        this.setCardIcons();
      }
    },
    newCardChange (newValue) {
      this.selectedCardId = null;
      this.newCard.number = newValue.replace(/ /g, '');
      if (this.newCard.number && this.newCard.number.trim() && this.newCard.number.replace(' ', '')) {
        let cardType = getCardType(this.newCard.number.replace(' ', ''));
        let index = this.cardIcons.findIndex(y => y.type === cardType);
        if (index > -1) {
          this.newCard.icon = this.cardIcons[index].icon;
          this.newCard.type = cardType;
        }
      }
      if (!this.newCard.number || !this.newCard.number.trim()) {
        this.newCardNumberMask = '';
        this.newCard.type = '';
        this.newCard.icon = 'credit-card.ico';
      } else {
        this.newCardNumberMask = this.newCard.number.replace(' ', '').replace(/.(?=.{4})/g, '#').match(/.{1,4}/g).join(' ');
      }
    },
    validateDateChange (value) {
      if (value && value.trim()) {
        let splited = this.newCard.expiry.trim().split(' / ');
        if (parseInt(splited[0], 10) > 12 || parseInt(splited[0], 10) < 1) {
          return false;
        }
        let currentYear = (new Date()).getFullYear();
        let currentMonth = (new Date()).getMonth() + 1;
        let lastTwo = currentYear.toString().substr(2);
        if (parseInt(splited[1], 10) < lastTwo || (parseInt(splited[1], 10) === lastTwo && currentMonth)) {
          return false;
        }
      }
      return true;
    },
    setCards () {
      this.cards = this.PaymentMode.map(mode => {
        mode.card.icon = 'credit-card.ico';
        mode.card.id = mode.id;
        return mode.card;
      });
    },
    async fetchPaymentModes () {
      if (!this.PaymentMode.length) {
        let where = { account: this.Account.id };
        let { error, data } = await getCollection('PaymentMode', true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.PaymentMode = data;
            /* Set the local card variable */
            this.setCards();
          }
        }
      } else {
        this.setCards();
      }
    },

    setCardIcons () {
      this.cards = this.cards.map((x) => {
        let index = this.cardIcons.findIndex(y => y.type === x.type);
        if (x.type && index > -1) {
          x.icon = this.cardIcons[index].icon;
        }
        return x;
      });
    },
    async checkout () {
      if (!this.selectedCardId && !(this.newCard.number || this.newCard.name || this.newCard.expiry || this.newCard.cvv)) {
        swal.fire({
          type: 'error',
          title: 'Please add or select a card',
          showConfirmButton: false,
          timer: 1500
        });
        return;
      }
      let cardFormValid = true;
      if (!this.selectedCardId) {
        cardFormValid = this.$refs.checkoutForm.validate();
      }
      if ((cardFormValid || this.selectedCardId) && this.payment) {
        let payload = {
          account: this.Account.id,
          agency: this.paymentAgency.id,
          ...this.payment,
          basic_details: {
            parent1: {
              first_name: this.Account.human[0].first_name,
              last_name: this.Account.human[0].first_name || ''
            },
            username: this.Account.nickname,
            membership: this.Account.membership,
            phone: this.Account.contactInfo.phone,
            email: this.Account.contactInfo.email
          },
          address: {
            line_1: this.Account.contactInfo.line_1,
            line_2: this.Account.contactInfo.line_2,
            city: this.Account.contactInfo.city,
            state: this.Account.contactInfo.state && this.Account.contactInfo.state.name ? this.Account.contactInfo.state.name : '',
            zip: this.Account.contactInfo.zip,
            country: this.Account.contactInfo.country && this.Account.contactInfo.country.name ? this.Account.contactInfo.country.name : ''
          },
        };
        if (this.selectedCardId) {
          payload.payment_mode = this.selectedCardId;
        } else if (this.newCard) {
          payload.card = JSON.parse(JSON.stringify(this.newCard));
          delete payload.card.icon;
          delete payload.card.name;
          // delete payload.card.type;
          /* format the card details */
          payload.card.number = payload.card.number.replace(/ /g, '');
          payload.card.expiry = payload.card.expiry.replace(' / ', '');
          payload.card.cvv = payload.card.cvv.replace(/ /g, '');

        } else {
          swal.fire({
            type: 'error',
            text: `You have to add or select the card to checkout`,
            showConfirmButton: true,
            timer: 2500
          });
          return;
        }

        window.getApp.$emit('LoadingText', 'Please wait.. We\'re processing your payment and setting up the subscription.');
        let { error, data } = await request('Payment/AddNewAgency', 'POST', payload);
        if (error) {
          console.log(error);
          swal.fire({
            type: 'warning',
            title: 'Error',
            text: `${error.message || error}, please try again. If problem persists please contact support at support@parentfinder.com`,
            showConfirmButton: true,
            timer: 2500
          });
        } else if (data) {
          this.newCard = {
            name: '',
            number: '',
            expiry: '',
            icon: 'credit-card.ico',
            type: '',
            cvv: ''
          };
          this.selectedCardId = null;
          this.isSelectCard = false;
          this.payment = null;
          swal.fire({
            type: 'success',
            title: 'Payment successful',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.closePaymentModal();
            }
          });
        } else {
          swal.fire({
            type: 'error',
            title: 'Failed to process the request, please try again',
            showConfirmButton: false,
            timer: 2500
          });
        }
        window.getApp.$emit('LoadingText', 'Loading');
      }
    },
    closePaymentModal () {
      this.processPendingPayments = false;
      this.AgenciesRequiredPayment = this.AgenciesRequiredPayment.filter(x => x.id !== this.paymentAgency.id);
    },

    getJoinDate (account) {
      let joinDate = account.find(account => account.account === this.Account.id);
      if (joinDate) {
        return joinDate.createdAt;
      }  
    },
   
    async initialize () {

      if (this.Account && (this.Account.id || this.Account._id)) {
        let where = { 'account.account': this.Account.id || this.Account._id };
        let attributes = 'name,createdAt,account,_id';
        let populate = [{ path: 'human', select: '_id name user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
        } else {
          this.MyAgencies = data;
        }
      }
    },
    formatDate (dateString, format) {
      return formatDate(dateString, format);
    },
    setDefaultContact (item) {
      this.Account.default_agency = item.id;
      this.Account.updated_from = 'default';
      this.saveAccount('Account');
    },
    async saveAccount (entity) {
      let { error, data, status } = await update(entity, this.Account, session.getSession().adminUser ? session.getSession().user.human.account.id : 'Me');
      if (error) {
        console.log('error', error);
      } else {
        this.Account = data;
        this.loading = false;
        swal.fire({
          type: 'success',
          title: 'Details saved successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
          }
        });
      }
    },
    async handleRemoveAgency (item, unsubscribe = false, isRemoveFromPayment = false) {
      let agencyIndex = this.Account.agency.findIndex(agency => agency.agency === item.id);
      this.Account.agency.splice(agencyIndex, 1);
      const payload = { ...this.Account };
      if (unsubscribe) {
        payload.isUnsubscribe = unsubscribe;
        payload.unSubscribeAgency = item.id;
      }
      let { error, data, status } = await update('Account', payload, session.getSession().adminUser ? session.getSession().user.human.account.id : 'Me');
      if (error) {
        console.log('error', error);
      } else {
        this.Account = data;
        if (isRemoveFromPayment) {
          this.closePaymentModal();
        }
        let TimelineObj = {
          text: `You removed agency '${item.name}' from the list`,
          title: 'Removed Agency',
        };
        if (session.getSession().adminUser) {
          TimelineObj.account = session.getSession().user.human.account.id;
        }
        let { TimelineError, timelineData } = await create('Timeline', TimelineObj);
        if (TimelineError) {
          console.log('error', TimelineError);
        }
        let removedAgencyIndex = this.MyAgencies.findIndex(agency => agency.id === item.id);
        this.MyAgencies.splice(removedAgencyIndex, 1);
        swal.fire(
          'Deleted!',
          'The agency "' + item.name + '" has been deleted from the list.',
          'success'
        );
      }
    },
    async removeRequest (item, isRemoveFromPayment = false) {
      swal.fire({
        title: 'Are you sure?',
        text: "You'll be removed from this agency. You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            // Check if an active payment subscriptionn exists if not default agency
            if (this.Account.default_agency !== item.id) {
              // Request to get the active subscription
              let { error: subscriptionError, data: subscriptionData } = await getCollection('PaymentSubscription', true, 10, '', { 'account': this.Account.id, 'status': 'Subscribed', agency: item.id });
              if (subscriptionError) {
                console.log('subscriptionError', subscriptionError);
              } else if (subscriptionData.length) {
                swal.fire({
                  type: 'warning',
                  title: 'Unsubscribe',
                  text: 'You have an active subscription with this agency. This will unsubscribe before removing the agency.',
                  showCancelButton: true,
                  confirmButtonText: 'Unsubscribe',
                  cancelButtonText: 'Cancel',
                }).then(async (confirm) => {
                  if (confirm.value) {
                    // Unsubscribe the active subscription with an additional parameter
                    await this.handleRemoveAgency(item, true);
                  }
                });
              } else {
                await this.handleRemoveAgency(item, false, isRemoveFromPayment);
              }
            }
          })();
        }
      });
    }
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/MyAgencies.vue